var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1039,
    viewBox: "0 0 1440 1039",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_2514_42616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.714 0H0V115.41H205.714V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 0H205.714V115.41H411.428V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 0H411.429V115.41H617.143V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 0H617.143V115.41H822.857V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 0H822.857V115.41H1028.57V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 0H1028.57V115.41H1234.29V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H1234.29V115.41H1440V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 0H1440V115.41H1645.71V0Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 115.41H0V230.82H205.714V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 115.41H205.714V230.82H411.428V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 115.41H411.429V230.82H617.143V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 115.41H617.143V230.82H822.857V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 115.41H822.857V230.82H1028.57V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 115.41H1028.57V230.82H1234.29V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 115.41H1234.29V230.82H1440V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 115.41H1440V230.82H1645.71V115.41Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 230.82H0V346.231H205.714V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 230.82H205.714V346.231H411.428V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 230.82H411.429V346.231H617.143V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 230.82H617.143V346.231H822.857V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 230.82H822.857V346.231H1028.57V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 230.82H1028.57V346.231H1234.29V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 230.82H1234.29V346.231H1440V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 230.82H1440V346.231H1645.71V230.82Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 346.23H0V461.641H205.714V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 346.23H205.714V461.641H411.428V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 346.23H411.429V461.641H617.143V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 346.23H617.143V461.641H822.857V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 346.23H822.857V461.641H1028.57V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 346.23H1028.57V461.641H1234.29V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 346.23H1234.29V461.641H1440V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 346.23H1440V461.641H1645.71V346.23Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 461.641H0V577.051H205.714V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 461.641H205.714V577.051H411.428V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 461.641H411.429V577.051H617.143V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 461.641H617.143V577.051H822.857V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 461.641H822.857V577.051H1028.57V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 461.641H1028.57V577.051H1234.29V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 461.641H1234.29V577.051H1440V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 461.641H1440V577.051H1645.71V461.641Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 577.051H0V692.461H205.714V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 577.051H205.714V692.461H411.428V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 577.051H411.429V692.461H617.143V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 577.051H617.143V692.461H822.857V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 577.051H822.857V692.461H1028.57V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 577.051H1028.57V692.461H1234.29V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 577.051H1234.29V692.461H1440V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 577.051H1440V692.461H1645.71V577.051Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 692.461H0V807.871H205.714V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 692.461H205.714V807.871H411.428V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 692.461H411.429V807.871H617.143V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 692.461H617.143V807.871H822.857V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 692.461H822.857V807.871H1028.57V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 692.461H1028.57V807.871H1234.29V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 692.461H1234.29V807.871H1440V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 692.461H1440V807.871H1645.71V692.461Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 807.871H0V923.282H205.714V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 807.871H205.714V923.282H411.428V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 807.871H411.429V923.282H617.143V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 807.871H617.143V923.282H822.857V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 807.871H822.857V923.282H1028.57V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 807.871H1028.57V923.282H1234.29V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 807.871H1234.29V923.282H1440V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 807.871H1440V923.282H1645.71V807.871Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 923.282H0V1038.69H205.714V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.428 923.282H205.714V1038.69H411.428V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.143 923.282H411.429V1038.69H617.143V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 923.282H617.143V1038.69H822.857V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.57 923.282H822.857V1038.69H1028.57V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.29 923.282H1028.57V1038.69H1234.29V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 923.282H1234.29V1038.69H1440V923.282Z",
    stroke: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.71 923.282H1440V1038.69H1645.71V923.282Z",
    stroke: "#E8E8DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_42616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1039,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.68dd2e5fc82c6005965c77b2ddf25805.svg";
export { ForwardRef as ReactComponent };